module.exports = __webpack_public_path__ + "static/media/maimai_shutle.13239746.jpg";